import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "run-nginx"
    }}>{`Run Nginx`}</h2>
    <p>{`To enable cezerin apps from browser, we need to setup web server.`}</p>
    <p>{`We need to proxy all requests from web to our cezerin apps.`}</p>
    <p>{`All requests from domain.com proxy to localhost:3000 (running cezerin frontend
app)`}</p>
    <p>{`All requests from domain.com/api, domain.com/ajax, domain.com/images proxy to
localhost:3001 (running cezerin backend app)`}</p>
    <p>{`We have cezerin nginx config, so you can use this config for web deploy (just
remove default config settings and replace with cezerin config settings).`}</p>
    <p><a parentName="p" {...{
        "href": "https://raw.githubusercontent.com/cezerin2/cezerin2/master/docs/nginx.md"
      }}>{`cezerin nginx config`}</a></p>
    <p>{`P.S. Change /var/www/cezerin2/ in nginx config to your path if you download
cezerin to another folder.`}</p>
    <p>{`We need to add a new website to Nginx.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Change Nginx config file`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /etc/nginx/sites-available
`}</code></pre>
        <p parentName="li">{`open `}<inlineCode parentName="p">{`default`}</inlineCode>{` file and paste
`}<a parentName="p" {...{
            "href": "https://raw.githubusercontent.com/cezerin2/cezerin2/master/docs/nginx.md"
          }}>{`this config`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Reload Nginx configuration`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`nginx -t && service nginx reload
`}</code></pre>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      